// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1QzDQ","additionalInfo":"AgreementModal_additionalInfo__1YlSa"};